import { PopupExtendedContext, PopupExtendedContextType } from 'core/contexts/popup-extended.context';
import { createAutoUnmountPopupManager } from 'core/providers/popup-manager.factory';
import { useReducer, useState } from 'react';
import { PopupProvider } from 'react-popup-manager';

type ActionType = {
    type: string;
    payload: Record<string, NonNullable<unknown> | undefined>;
};

const reducer = (state: PopupExtendedContextType, action: ActionType) => {
    switch (action.type) {
        case 'SET_DATA':
            return {
                ...state,
                data: {
                    ...state.data,
                    ...action.payload,
                },
            };
        case 'RESET_DATA':
            return {
                ...state,
                data: {},
            };
        default:
            return { ...state };
    }
};

export const PopupExtendedProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
    const [popupManager] = useState(createAutoUnmountPopupManager);

    const setData = (type: string, data: Record<string, NonNullable<unknown> | undefined>) => {
        dispatch({ type, payload: data });
    };

    const initState = {
        data: {},
        setData,
    };

    const [state, dispatch] = useReducer(reducer, initState);

    return (
        <PopupExtendedContext.Provider value={state}>
            <PopupProvider popupManager={popupManager}>{children}</PopupProvider>
        </PopupExtendedContext.Provider>
    );
};
